export default{
    
    user: JSON.parse(localStorage.getItem('user')) || null,
    date: null,
    showMenu: true,
    isLogged: !!localStorage.getItem('access_token'),
    error: false,
    errorMessage: '',
    access_token: localStorage.getItem('access_token') || '',
    token_device: '',

    rutaDocumentosPresupuestos: '',
    rutaDocumentosConfirmaciones: '',
    rutaDocumentosContratos: '',
    rutaDocumentosFacturas: '',

}